module.exports = vendors_1f11f3efdf58eb3478bb;